<template>
    <div class="details">
        <Spin size="large" fix v-if="spinShow"></Spin>
        <navbar></navbar>
        <h1 class="profile-title details-width">{{$t('user_center_order_order_details')}}</h1>
            <steps :current="1" v-if="status_title == 'a' ">
                <step :title="$t('order_details_state_1')"></step>
                <step :title="$t('order_details_state_2')"></step>
                <step :title="$t('order_details_state_3')"></step>
            </steps>
            <steps :current="2" v-if="status_title == 'b' ">
                <step :title="$t('order_details_state_1')"></step>
                <step :title="$t('order_details_state_2')"></step>
                <step :title="$t('order_details_state_3')"></step>
            </steps>
        <div class="order-list">
            <h3 class="listing details-width">{{$t('Order_Details_Listing')}}</h3>
            <div class="order-group">
                <div class="order-group-header details-width">
                    <Row>
                        <i-col span="4">&nbsp;</i-col>
                        <i-col span="4">{{$t('user_center_order_product')}}</i-col>
                        <i-col span="4">{{$t('user_center_order_price')}}</i-col>
                        <i-col span="4">{{$t('user_center_order_Quantity')}}</i-col>
                        <i-col span="4">{{$t('user_center_order_Subtotal')}}</i-col>
                        <i-col span="4">{{$t('user_order_operation')}} </i-col>
                    </Row>
                </div>
                <h3 class="details-width order-number">
                    {{$t('user_center_order_order_num')}}：{{orders_info.order_sn}}</h3>
                <div class="order-group-lists" v-if="screenWidth" >
                    <div class="order-group-list" v-for="order in orders">
                        <div class="order-content">
                            <Row>
                                <i-col span="4">
                                    <div class="order-col"><img :src="order.goods_img" width="100"></div>
                                </i-col>
                                <i-col span="4">
                                    <div class="order-col">
                                        <h3>{{order.goods_name}}</h3>
                                        <p>{{order.goods_remarks}}</p>
                                    </div>
                                </i-col>
                                <i-col span="4">
                                    <div class="order-col">
                                        <p class="order-col-title text-primary">{{order.goods_unit}}{{order.goods_price}}</p>
                                    </div>
                                </i-col>
                                <i-col span="4">
                                    <div class="order-col">
                                        <p class="order-col-title">{{order.goods_num}}</p>
                                    </div>
                                </i-col>
                                <i-col span="4">
                                    <div class="order-col selecte">
                                        <p class="order-col-title">
                                            {{order.goods_unit}}{{parseFloat(order.goods_price) * order.goods_num}}</p>
                                    </div>
                                </i-col>
                                <i-col span="4">
                                    <div class="order-col" v-if="orders_info.status_type == 1">
                                        <a style="color: red" @click="cancleOrder">
                                            {{$t('user_center_order_cancel_order')}}
                                        </a>
                                    </div>
                                    <div class="order-col" v-else-if="orders_info.status_type == 2">
                                        <span v-if="orders_status == 2">
                                            {{$t('user_order_not_for_deli')}}
                                        </span>
                                        <span v-else-if="orders_status == 3">
                                            {{$t('user_order_transporting')}}
                                        </span>
                                        <span v-else-if="orders_status == 5" style="color: red;">
                                            {{$t('user_order_canceled')}}
                                        </span>
                                    </div>
                                    <div class="order-col" v-else-if="orders_info.status_type == 3">
                                        <router-link
                                                :to="{name:'Aftermarket',params:{order_sn:orders_info.order_sn},query:{goods_id:order.goods_id,after_id:order.if_after}}"
                                                style="font-weight: normal">
                                            <a v-if="order.goods_status== 0">
                                                {{$t('user_center_order_return_exchange')}}
                                            </a>
                                            <a style="color: red;" v-else-if="order.goods_status== 1">
                                                {{$t('user_order_returning')}}
                                            </a>
                                            <a style="color: green;"  v-else-if="order.goods_status== 3">
                                                {{$t('user_order_return_completed')}}
                                            </a>
                                            <a style="color: green;"  v-else-if="order.goods_status== 9">
                                               {{$t('user_order_replacement_cancelled')}}
                                            </a>
                                        </router-link>
                                    </div>
                                </i-col>
                            </Row>
                        </div>
                    </div>
                </div>
                <div class="mobile-order-group-lists" v-else v-for="order in orders">
                    <div class="goods-header">
                        <img :src="order.goods_img" >
                    </div>
                    <div class="goods-desc">
                        <h3>
                            {{order.goods_name}}
                        </h3>
                        <p>${{order.goods_price}} x {{order.goods_num}}</p>
                        <div class="order-col">
                            <router-link
                                :to="{name:'Aftermarket',params:{order_sn:orders_info.order_sn},query:{goods_id:order.goods_id,after_id:orders[0].if_after}}"
                                style="font-weight: normal">
                                {{$t('user_center_order_return_exchange')}}
                            </router-link>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="order-payment details-width">
            <i-col :xs="24" :sm="12" :md="12">
                <div class="payment-left">
                    <h3>{{$t('Order_Details_Payment_and_logistics')}}</h3>
                    <p class="pay-method">{{$t('user_order_payment_method')}}：<span>{{orders_info.pay_type}}</span></p>
                    <p class="pay-time">
                        {{$t('Order_Details_Payment_time')}}：<span>{{parseFloat(orders_info.add_time * 1000) | formatDate}}</span>
                    </p>
                    <h3 class="take_away">{{$t('details_shipping_type')}}</h3>
                    <div class="take_way" v-if="take_type=='b'">
                        <p>{{$t('details_Pickup')}}:{{orders_info.stord_name}}</p>
                        <p>{{orders_info.stord_address}}</p>
                    </div>
                    <div class="take_way" v-else-if="take_type=='a'">
                        <p>{{$t('details_express')}}:{{orders_info.express_company}}</p>
                        <p>{{$t('details_Tracking_No')}}:{{orders_info.tracking_number}}</p>
                    </div>
                </div>
            </i-col>
            <i-col :xs="24" :sm="12" :md="12" class="order-details">
                <div class="payment-right">
                    <p>{{$t('Order_Details_Payment_Freight')}}：<span>+ {{orders_info.unit}} {{orders_info.shipping_price}}</span>
                    </p>
                    <p>{{$t('Order_Details_Payment_Real_Payment')}}: <span
                            class="real-pay text-primary">{{orders_info.unit}} {{orders_info.need_pay_usd_price}}</span>
                    </p>
                    <p>{{orders_info.username}}</p>
                    <p>{{orders_info.mobile}}</p>
                    <p>{{orders_info.address}}</p>
                </div>
            </i-col>
        </div>
        <div style="clear: both"></div>
    </div>

</template>

<script>
    import navbar from '../Common/Navbar.vue'
    import steps from '../MyDetails/Common/Steps.vue'
    import step from '../MyDetails/Common/Step.vue'
    import { formatDate } from '../../lib/date.js'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                orders: [],
                orders_info: {},
                spinShow:true,
                take_type:'',
                status_title:'',
                returning_status:'a'
            }
        },
        filters: {
            formatDate (time) {
                var date = new Date(time)
                return formatDate(date, 'yyyy-MM-dd hh:mm')
            }
        },
        components: {
            steps, step, navbar
        },
        computed: {
            selectedNum () {
                return this.goods.length
            },
            screenWidth: function () {
                return document.body.clientWidth > 500
            },
            orderTotal () {
                let total = 0
                for (let item of this.goods) {
                    if (item.if_checked === true) {
                        total += parseFloat(item.goods_price) * parseInt(item.goods_num)
                    }
                }
                return total
            },
            orderNumberTotal () {
                let total = 0
                for (let item of this.goods) {
                    if (item.if_checked === true) {
                        total += parseInt(item.goods_num)
                    }
                }
                return total
            }
        },
        methods: {
            cancleOrder () {
                let module = 'index.php/cancelorder'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.order_sn = this.$route.params.order_sn
                data.lang = this.$i18n.locale
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        if (parseFloat(resp.data.code) === 2000) {
                            this.$Message.success(this.$t('user_order_canceled'))
                            this.$router.push(
                                {
                                    name: 'EndOrder'}
                            )
                        }
                    }.bind(this))
            }
        }
        ,
        created () {
            let module = 'index.php/index/order/orderdetail'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$i18n.locale
            data.order_sn = this.$route.params.order_sn
            this.$http.get(process.env.BASEURL + module, {params: data})
            .then(function (response) {
                if(parseInt(response.data.code) === 2000){
                    console.log(response.data)
                    this.spinShow = false
                    this.orders = response.data.data.order_detail
                    this.orders_info = response.data.data.order_info
                    this.orders_info_type = response.data.data.order_info.order_type
                    this.orders_status = response.data.data.order_info.order_status
                    //判断订单状态
                    if (this.orders_status === 1) {
                        this.status_title = 'a'
                    }
                    if (this.orders_status === 2) {
                        this.status_title = 'a'
                    }
                    if (this.orders_status === 3) {
                        this.status_title = 'a'
                    }
                    if (this.orders_status === 4) {
                        this.status_title = 'b'
                    }
                    if (this.orders_status === 6) {
                        this.status_title = 'a'
                    }
                    if (this.orders_status === 7) {
                        this.returning_status = 'c'
                        this.status_title = 'a'
                    }
                    if (this.orders_status === 8) {
                        this.returning_status = 'b'
                        this.status_title = 'b'
                    }

                    if (this.orders_info_type === 2) {
                        this.take_type = 'b'
                    }
                    if (this.orders_info_type === 1) {
                        this.take_type = 'a'
                    }
                }

            }.bind(this))
        }

    }
</script>

<style lang="scss">
    @import "../../scss/common";

    .details-width {
        width: 90%;
        max-width: 1240px;
        margin: 0 auto;
    }

    .details {
        text-align: left;
        margin-top: 80px;
        @at-root .profile-title {
            font-weight: 500;
            font-size: 40px;
            color: #1F2D3D;
            text-align: left;
        }
        .order-payment {
            font-size: 16px;
            margin-bottom: 100px;
            line-height: 24px;
            margin-top:20px;
            .payment-left {
                .take_away{
                    margin-top: 15px;
                }
                .take_way{
                    margin-top: 10px;
                    padding-bottom: 20px;
                }
                line-height: 2;
                h3 {
                    font-size: 24px;
                    color: #1F2D3D;
                    letter-spacing: 0;
                    line-height: 26px;
                    font-weight: 500;
                }
                .pay-method{
                    margin-top: 10px;
                }
            }
            .order-details {
                float: none;
                display: flex;
                justify-content: flex-end;
                .payment-right {
                    color: #5E6D82;
                    line-height: 2;
                    text-align: right;
                    margin-top:6.5%;
                    .real-pay {
                        font-size: 24px;
                    }
                }
            }
        }
    }

    .text-primary {
        color: #0084FF;
    }

    .order-list {
        font-size: 16px;
        color: #5E6D82;
        letter-spacing: 0;
        line-height: 20px;
        .order-group-header {
            margin-bottom:10px;
            .ivu-col {
                font-size: 14px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 20px;
            }
        }
        .listing {
            font-size: 24px;
            color: #1F2D3D;
            letter-spacing: 0;
            line-height: 26px;
            font-weight: 400;
            margin:20px auto;
        }
        .order-content {
            background: #F9FCFF;
            padding: 20px 0;
            margin-bottom: 5px;
            & > div {
                width: 90%;
                max-width: 1240px;
                margin: 0 auto;
            }
            .order-col {
                height: 100px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                h3 {
                    font-size: 16px;
                }
            }

            .order-col-title {
                font-size: 24px;
            }
        }
        .order-group-list {
            .order-number {
                margin-bottom:10px;
                color: #5E6D82;
                font-weight: normal;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 24px;
                margin-top: 10px;
            }
        }
    }

    .flex-content {
        display: -webkit-flex;
        display: flex;
        /*-webkit-flex-flow: row nowrap; flex-flow: row nowrap;*/
        background-color: #F9FCFF;
        padding: 2%;
        .flex-box {
            -webkit-justify-content: center; /* Safari */
            justify-content: center;
        }
        .flex-item {
            position: relative;
            -webkit-justify-content: flex-end; /* Safari */
            justify-content: flex-end;
            ul {
                li:last-child {
                    position: absolute;
                    bottom: 0;
                }
            }
        }
    }

    .steps-int {
        display: none;
    }

    .flex-box {
        img {
            width: 100px;
        }
    }

    @media only screen and (max-width: 768px) {
        .details {
            padding: 0 5%;
            .profile-title {
                font-size: 25px;
            }
            .order-payment {
                margin-bottom: 20px;
                .payment-left {
                    p {
                        font-size: 14px;
                        span {
                            float: right;
                        }
                    }
                    h3 {
                        font-size: 20px;
                    }
                }
                .order-details {
                    display: block;
                    .payment-right {
                        text-align: left;
                        p {
                            font-size: 14px;
                            span {
                                float: right;
                            }
                            .real-pay {
                                font-size: 15px;
                            }
                        }
                    }

                }
            }
            .order-list {
                .order-group-header, .listing {
                    display: none;
                }
                .mobile-order-group-lists{
                    display: flex;
                    margin: 15px;
                    border-bottom: 1px solid #e6e6e6;
                .goods-header{
                    width: 35%;
                    img{
                        width: 100%;
                        max-width: 200px;
                        min-width: 100px;
                    }
                }
                .goods-desc{
                    width: 65%;
                    padding-left: 20px;
                    text-align: left;
                    h3{
                        font-size: 16px;
                    a{
                        float: right;
                        padding-right: 10px;
                    }
                }
                .order-col{
                    margin-bottom:10px;
                }
                p{
                    margin-right: 10px;
                    margin-bottom: 10px;
                    font-size: 15px;
                    line-height: 28px;
                    border-bottom: 1px solid #e6e6e6;
                }
                .goods-num .goods-num-editable {
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                .number {
                    min-width: 20px;
                    display: inline-block;
                    text-align: center;
                    margin: 0 5px;
                    font-size: 14px;
                }
                .goods-price{
                    font-size: 16px;
                    padding-left: 25px;
                }
                }
                }
                }
                .order-number {
                    font-size: 16px;
                    margin: 2% auto;
                    font-weight: 500;
                }
                .flex-box {
                    img {
                        width: 100px;
                    }
                }
            }

        }
        .steps-int {
            display: block !important;
        }
    }

    @media only screen and (max-width: 320px) {
        .details {
            .order-list {
                .order-group-header, .order-number, .listing {
                    display: none;
                }
                .flex-box {
                    img {
                        width: 100px;
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 1024px) {
        .details {
            padding: 0 5% !important;
            .details-width {
                width: 100%;
            }
        }
        .order-list .order-content > div {
            width: 100%;
        }
        .steps {
            width: 100% !important;
            .step-list {
                width: 100% !important;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// MyDetails.vue?132a5636